import { useState } from "react";

import BackArrow from "../components/ui/BackArrow";
import LanguageSelector from "../components/LanguajeSelector";
import LoadingComponent from "../components/Loading";
import SendedComponent from "../components/Sended";

import JoinForm from "../components/JoinForm";
import ProgressLines from "../components/ProgressLines";

const FORM_STATE = {
  FILLLING: 1,
  LOADING: 2,
  SENDED: 3,
};

export default function JoinPage() {
  const [step, setStep] = useState(1);
  const [formState, setFormState] = useState(FORM_STATE.FILLLING);

  return (
    <main className="text-white flex flex-col items-center min-h-dvh gap-4 p-4">
      <LanguageSelector />
      <BackArrow />
      <ProgressLines steps={4} currentStep={step}/>


      {formState == FORM_STATE.FILLLING && (
        <JoinForm setFormState={setFormState} setStep={setStep} step={step}/>
      )}

      {formState === FORM_STATE.LOADING && (
        <section className="flex flex-col items-center justify-center gap-4 py-24 h-dvh">
          <LoadingComponent />
        </section>
      )}

      {formState === FORM_STATE.SENDED && (
        <section className="flex flex-col items-center justify-center gap-4 text-center h-dvh">
          <SendedComponent />
        </section>
      )}

      
    </main>
  );
}
